import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormControl } from "@mui/material";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
dayjs.extend(customParseFormat);
function DateField(_a) {
    var fieldInfo = _a.fieldInfo, formik = _a.formik;
    var fieldName = fieldInfo.name;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var handleChange = function (date) {
        if (date) {
            var formattedDate = date.format("DD-MM-YYYY");
            formik.setFieldValue(fieldName, formattedDate);
        }
        else {
            formik.setFieldValue(fieldName, "");
        }
    };
    var formikFieldValue = formik.values[fieldName]
        ? dayjs(formik.values[fieldName], "DD-MM-YYYY")
        : null;
    return (_jsx(FormControl, { fullWidth: true, className: "my-2", disabled: formik.isSubmitting, children: _jsx(DatePicker, { label: fieldInfo.label, format: "DD-MM-YYYY", value: formikFieldValue, onChange: handleChange, open: open, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, slotProps: {
                popper: {
                    onMouseDown: function (e) {
                        e.stopPropagation(); // prevents parent blur
                    },
                },
            } }) }));
}
export default DateField;
